// File: DirectorPartnerChanges.jsx
import React from "react";

export default function DirectorPartnerChanges() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Director & Partner Changes
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Professional Compliance Support by Hawkins &amp; Brooks
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks manages director and partner changes with MCA compliance.
          </p>
          <p className="text-gray-700">
            Complete director appointment/removal, designated partner addition services including DIR-12, Form 3/4, consent forms, board resolutions, DIN activation, and MCA statutory updates.
          </p>
        </div>

        {/* Right: Image (DIRECTOR/PARTNER CHANGES SPECIFIC) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/3184411/pexels-photo-3184411.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Director and partner change compliance services by Hawkins & Brooks"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks ensures complete documentation for seamless director/partner changes.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>DIR-2 consent forms</li>
                <li>Board/partner resolutions</li>
                <li>Identity proof & address proof</li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              Accurate statutory filings ensuring complete MCA compliance for director/partner changes.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Companies Act Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Complete knowledge of Companies Act 2013 Section 152/168 & LLP Act requirements including DIR-12 filing (within 30 days), DIR-2 consents, board resolutions, DIN/Designated Partner Number activation, and disqualification compliance.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate MCA Filings
                </h3>
                <p className="text-gray-700 text-sm">
                  Precise DIR-12, Form 3/4 e-filings with DIR-2 consents, DSC validations, KYC documentation, statutory register updates, MCA approval tracking, DIR-3 KYC compliance, and penalty avoidance (₹500-5,000) through timely submissions.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  End-to-End Process
                </h3>
                <p className="text-gray-700 text-sm">
                  Full-service director/partner changes from consent collection through resolution drafting, DIN/DP number allocation, MCA form preparation, statutory register updates, board meeting documentation, and ongoing compliance advisory.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
